import { FC } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { centralized } from "./styled";
import { HashLink } from "react-router-hash-link";

type HeaderProps = {
    children?: React.ReactNode;
};

const Header: FC<HeaderProps> = ({ children }) => (
    <HeaderContainer>
        <HeaderContent>
            <Link to='/' reloadDocument={true}>
                <OFTDLogo />
            </Link>
            {children}
        </HeaderContent>
    </HeaderContainer>
);

export default Header;

export const HeaderContainer = styled.header`
    grid-area: header;
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgb(249, 241, 221);
    border-bottom: 1px solid rgb(238, 210, 177);
    @media (max-width: 1240px) {
        width: 100vw;
        border-bottom: 1px solid rgb(238, 210, 177);
    }
`;

export const HeaderContent = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    height: 100%;
    ${centralized};
`;

export const HeaderLogo = styled.img`
    height: 42px;
    justify-self: start;
    @media (max-width: 1480px) {
        height: 32px;
    }
    @media (max-width: 1240px) {
        height: 18px;
    }
`;

export const OFTDLogo: FC = () => {
    return <HeaderLogo src={process.env.PUBLIC_URL + "/logo.svg"} />;
};

export const HeaderButton = styled(HashLink)`
    color: #e38146;
    font-size: 30px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: -1px;
    text-decoration: none;
    justify-self: end;
    &:hover {
        opacity: 0.7;
    }
    @media (max-width: 1480px) {
        font-size: 28px;
    }
    @media (max-width: 1240px) {
        font-size: 24px;
    }
    @media (max-width: 1240px) {
        font-size: 18px;
    }
`;

export const HeaderMobileMenu = styled.button`
    background: url("${process.env.PUBLIC_URL}/index/mobile_menu.svg");
    background-repeat: no-repeat;
    border: none;
    justify-self: end;
    height: 40px;
    width: 32px;
`;

export const HeaderMobileMenuClose = styled.button`
    background: url("${process.env.PUBLIC_URL}/index/close_menu.svg");
    background-repeat: no-repeat;
    border: none;
    justify-self: end;
    height: 25px;
    width: 25px;
`;

export const LocalizationButton = styled.button`
    background: url("${process.env.PUBLIC_URL}/index/localize.svg");
    background-repeat: no-repeat;
    border: none;
    height: 21px;
    width: 35px;
`;
